import React, { useEffect, useRef } from 'react';
import CategoryHeroSlideshow from '../components/Home/CategoryHeroSlideshow';
import FeaturedTours from '../components/Home/FeaturedTours';
import FeaturedToursCards from '../components/Home/FeaturedToursCards';
import VoiceDemo from '../components/VoiceAgent/VoiceDemo';
import PricingFilter from '../components/Common/PricingFilter';
import ForYouSection from '../components/Home/ForYouSection';
import SEO from '../components/Common/SEO';
import { useLoading } from '../contexts/LoadingContext';

const Home: React.FC = () => {
  const { showSplash } = useLoading();
  const hasLoaded = useRef(false);

  useEffect(() => {
    // Only trigger on subsequent navigations, not the initial app boot 
    // (which is handled by AppSplashScreen's own internal initial effect)
    if (hasLoaded.current) {
      showSplash();
    }
    hasLoaded.current = true;
  }, [showSplash]);

  return (
    <div className="relative">
      <SEO />
      <CategoryHeroSlideshow />
      <div className="relative z-20">
        <PricingFilter />
      </div>
      <ForYouSection />
      <FeaturedTours />
      <FeaturedToursCards />
      <VoiceDemo />
    </div>
  );
};

export default Home;
